import axios from '../utils/axios';

export default function fetchPremiumPostingAdoption(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/premium-posting-adoption', {
            params: params
        })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
